// Camada de acesso à API partilhada (TS) — reutiliza a mesma sessão JWT do
// apiFetch legado do App.js. A sessão pode viver em sessionStorage (login
// normal) OU em localStorage ("Memorizar neste dispositivo") — ler só o
// sessionStorage deixava TODOS os pedidos deste módulo (ex: conciliação)
// sem token quando a sessão era memorizada.
import { getMockData } from "../mockData";
import { notifyDataChanged } from "./dataSync";

export const API = process.env.REACT_APP_API_URL || "http://localhost:8000";
export const IS_MOCK = process.env.REACT_APP_MOCK === "true";
const SESSION_KEY = "accounting_agent_session";

function getToken(): string | null {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY) || localStorage.getItem(SESSION_KEY);
    return raw ? JSON.parse(raw).token : null;
  } catch {
    return null;
  }
}

export async function apiFetch(path: string, options: RequestInit = {}): Promise<Response> {
  const headers: Record<string, string> = { ...(options.headers as Record<string, string>) };
  const token = getToken();
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const r = await fetch(`${API}${path}`, { ...options, headers });
  if (r.status === 401 && token) {
    sessionStorage.removeItem(SESSION_KEY);
    localStorage.removeItem(SESSION_KEY);
    window.location.reload();
  }
  notifyDataChanged(path, options, r);
  return r;
}

// GET tipado para React Query: respeita modo mock e lança em erro (para isError).
export async function apiGet<T = unknown>(path: string): Promise<T> {
  if (IS_MOCK) {
    return getMockData(path) as T;
  }
  const r = await apiFetch(path);
  if (!r.ok) {
    let detail = `HTTP ${r.status}`;
    try {
      const j = await r.json();
      // `detail` pode vir como string OU como objeto estruturado (vários
      // endpoints devolvem {msg, ...} para a UI poder reagir ao motivo).
      // Passar o objeto direto a new Error() dava "[object Object]" ao
      // utilizador em vez da mensagem.
      if (typeof j.detail === "string") detail = j.detail;
      else if (j.detail?.msg) detail = j.detail.msg;
    } catch {
      /* corpo não-JSON */
    }
    throw new Error(detail);
  }
  return r.json() as Promise<T>;
}
